module.exports = __webpack_public_path__ + "static/media/thumbnail.1b1dec20.jpg";